import moment from 'moment';

// TODO: Unit test this.
export const prettyDate = (date: number | null | undefined): string | null =>
  date ? moment(date).local().format('YYYY-MM-DD HH:mm') : null;
